import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { KmlComponent } from './kml.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    KmlComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    SharedModule
  ]
})
export class KmlModule { }
